<template>
  <div class="pg-criteria-form flex" @enter="handleModelEnter">
    <PgCriteriaFormBasic
      class="pg-criteria-form_form"
      ref="criteriaFormRef"
      :model="formData"
      :formItems="formItems"
      :collapse="open"
      @on-enter="search"
    ></PgCriteriaFormBasic>
    <div
      class="pg-criteria-form_btn"
      :class="{
        'pg-criteria-form_btn-label-top':
          formItems?.form?.property?.labelPosition !== 'left' &&
          formItems?.form?.property?.labelPosition !== 'right',
      }"
    >
      <div class="flex">
        <Button
          type="primary"
          round
          @click="search"
          style="margin-left: 10px"
          :loading="searchLoading"
          >查询</Button
        >
        <Button type="danger" round @click="removeAll" style="margin-left: 10px" v-if="!hideClear"
          >清空</Button
        >
        <Dropdown
          size="mini"
          split-button
          type="primary"
          style="margin-left: 10px"
          class="pg-criteria-form_btn-save"
          @click="saveCriteriaItem"
          v-if="!hideSave"
        >
          保存
          <DropdownMenu slot="dropdown" v-if="criteriaList.length > 0">
            <DropdownItem v-for="item in criteriaList" :key="item.id">
              <p
                class="flex flex-pack-justify flex-align-center"
                style="width: 200px"
                @click="getCriteriaParam(item.id)"
              >
                <span>{{ item.name }}</span>
                <i
                  class="el-icon-close"
                  style="font-size: 14px"
                  @click.stop="removeCriteriaListItem(item.id)"
                ></i>
              </p>
            </DropdownItem>
          </DropdownMenu>
          <DropdownMenu slot="dropdown" v-else>
            <DropdownItem><p style="width: 200px; text-align: center">暂无数据</p></DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Button
          type="text"
          class="pg-criteria-form_btn-more"
          :disabled="!moreDisabled"
          @click="handleOpen(!open)"
          v-if="!hideCollapse"
          >{{ open ? '收起' : '展开' }}</Button
        >
      </div>
      <CollapseTransition :second="0.3" v-if="showOtherOptions">
        <slot v-if="open"></slot>
      </CollapseTransition>
    </div>
  </div>
</template>
<script setup>
// vue
import { ref, computed, onMounted } from 'vue'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
// 组件
import PgCriteriaFormBasic from './criteria-form-basic.vue'
import { pgMessage } from '../../message/index'
import { Dropdown, DropdownMenu, DropdownItem, MessageBox, Button } from 'element-ui'

// hook
import { CRITERIFORMCOLUM } from '../hook/use-common-param'
import { post, get, filters } from '../../../utils/index'

const emit = defineEmits(['search', 'clear', 'getCriteriaParam'])

const props = defineProps({
  formData: Object, //form 值
  //form 的配置
  formItems: {
    type: [Array, Object],
    default: null,
  },
  formSaveUrl: {
    type: Object,
    default: () => {
      return {
        save: 'rest/ezcomp/dict/criteria/menu/submit',
        get: 'rest/ezcomp/dict/criteria/menu/options',
        remove: 'rest/ezcomp/dict/criteria/menu/remove',
        getSaveParam: 'rest/ezcomp/dict/criteria/menu/getOfEdit',
      }
    },
  },
  showOtherOptions: {
    type: Boolean,
    default: false,
  },
  //设置查询条件默认展开
  collapse: Boolean,
  hideClear: Boolean,
  hideCollapse: Boolean,
  hideSave: Boolean,
  searchLoading: Boolean,
})

// -------------------- 高级查询-form表单部分 --------------------
const open = ref(props.collapse ?? false) // false 收起  true:展开

// -------------------- 操作按钮部分 --------------------
// 展开收起-按钮 disabled
const moreDisabled = computed(() => {
  return (
    props.formItems.items?.length > (props.formItems?.form?.property?.colNum ?? CRITERIFORMCOLUM) ||
    props.showOtherOptions
  )
})

// 展开收起-方法 disabled
const handleOpen = (type) => {
  open.value = type
}

const criteriaFormRef = ref(null)
// 查询按钮
const search = async (callback, showError = true) => {
  const res = await criteriaFormRef.value.validate()
  // 报表平台，resize事件发生时，还需要判断一下查询条件是否满足，但是，不能展示提示，不够友好
  if (res) {
    if (showError) pgMessage.error('请完善必填信息！')
  } else {
    emit('search')
    if (callback && typeof callback === 'function') callback()
  }
}

// 清空按钮
const removeAll = () => {
  emit('clear')
}

// 保存条件
const criteriaList = ref([])
//获取保存的查询条件
const getCriteriaItem = async (id) => {
  const [res] = await get(props.formSaveUrl.getSaveParam, { id })
  const resData = res?.data?.parameter ?? {}
  //特殊值转换
  for (const key in resData) {
    if (resData[key] && typeof resData[key] === 'string' && resData[key].indexOf('$today') != -1) {
      const nowTime = new Date().getTime()
      resData[key] = filters(nowTime, 'date', 'YYYY-MM-DD')
    }
  }
  return resData
}
// 点击条件获取高级查询参数
const getCriteriaParam = async (id) => {
  const params = await getCriteriaItem(id)
  emit('getCriteriaParam', params)
  search()
}

// 窗口打开标志
const saveModelIsOpen = ref(false)

const handleModelEnter = () => {
  if (saveModelIsOpen.value) {
    saveCriteriaItem()
  }
}
// 保存查询条件
const saveCriteriaItem = () => {
  saveModelIsOpen.value = true
  MessageBox.prompt('请输入查询标题', '保存查询条件', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    customClass: 'pg-criteria-form_save-model',
    showCancelButton: false,
    inputPlaceholder: '请输入查询标题',
    roundButton: true,
    inputPattern: /.+/,
    inputErrorMessage: '请输入保存查询标题',
  })
    .then(async ({ value }) => {
      const param = {
        criteria: props.formItems.id,
        parameter: props.formData,
        name: value,
      }
      const [res] = await post(props.formSaveUrl.save, param)
      if (res) {
        saveModelIsOpen.value = false
        pgMessage.info(res.msg)
        getCriteriaList()
      }
    })
    .catch(() => {
      saveModelIsOpen.value = false
    })
}

// 获取已保存条件
const getCriteriaList = async () => {
  if (props.hideSave) return
  const param = {
    criteria: props.formItems.id,
    preset: false,
  }
  const [res] = await get(props.formSaveUrl.get, param, { errorTip: '' })
  if (res) {
    criteriaList.value = res.data
  } else {
    criteriaList.value = []
  }
}

// 删除已保存条件
const removeCriteriaListItem = async (id) => {
  const param = {
    id,
  }
  const [res] = await post(props.formSaveUrl.remove, param)
  if (res) {
    pgMessage.info(res.data)
    getCriteriaList()
  }
}

onMounted(() => {
  getCriteriaList()
})

defineExpose({
  search,
  getCriteriaItem, //通过id获取保存的查询条件
})
</script>
<style lang="scss">
@import '../style/criteria-form.scss';
@import '~element-ui/lib/theme-chalk/message-box.css';
</style>
